import React from 'react'

import IconPlay from '../icons/IconPlay.svg'
import ButtonRemarkable from './ButtonRemarkable'

const ButtonPlay = ({
  onClick,
  label = 'Play',
  disabled,
  blurOpacity = 1.0,
  width = 118,
  fontSize = '20px',
  fastAnimation
}) => {
  return (
    <ButtonRemarkable
      fastAnimation={fastAnimation}
      blurOpacity={blurOpacity}
      width={width}
      fontSize={fontSize}
      iconBefore={(
        <IconPlay
          width={12}
        />
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </ButtonRemarkable>
  )
}

export default ButtonPlay
